(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-filtration-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lq-filtration-video')) {
    customElements.define('lq-filtration-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.video.addEventListener('pause', () => {
          if (this.autoPausing) { this.autoPausing = false; return; }
          this.userPaused = true;
        }, options);
        this.video.addEventListener('play', () => { this.userPaused = false; }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          if (this.inView && !this.video.getAttribute('src')) {
            if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
            this.video.src = this.video.dataset.src;
            this.video.load();
          }
          this.updatePlayback();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => this.updatePlayback(), options);
      }

      async updatePlayback() {
        if (!this.inView || document.hidden) {
          if (!this.video.paused) { this.autoPausing = true; this.video.pause(); }
          return;
        }
        if (this.dataset.autoplay !== 'true' || this.motion.matches || this.userPaused) return;
        try { await this.video.play(); } catch { /* Native controls remain available when autoplay is blocked. */ }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-product-breakthrough"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lq-scroll-to-buy]');
    if (!trigger) return;

    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!productInfo) return;

    event.preventDefault();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    productInfo.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-product-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lq-scroll-to-buy]');
    if (!trigger) return;

    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!productInfo) return;

    event.preventDefault();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    productInfo.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-product-five-spray-modes"] && !Shopify.designMode) return;
  try {
    
  class LqProductSprayShowcase extends HTMLElement {
    #tabs = [];
    #panels = [];
    #copies = [];
    #controller = null;
    #track = null;
    #resizeObserver = null;
    #scrollTimer = null;
    #activeIndex = 0;
    #drag = null;

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.#tabs = [...this.querySelectorAll('[data-spray-tab]')];
      this.#panels = [...this.querySelectorAll('[data-spray-panel]')];
      this.#copies = [...this.querySelectorAll('[data-spray-copy]')];
      this.#track = this.querySelector('.lq-five-spray__panels');

      if (!this.#track || !this.#tabs.length || this.#tabs.length !== this.#panels.length) return;

      this.#controller = new AbortController();
      const signal = this.#controller.signal;
      this.dataset.enhanced = 'true';
      for (const panel of this.#panels) panel.hidden = false;

      const selectedIndex = this.#tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.#activate(selectedIndex >= 0 ? selectedIndex : 0, false, 'instant');

      for (const [index, tab] of this.#tabs.entries()) {
        tab.addEventListener('click', () => this.#activate(index, false), { signal: this.#controller.signal });
        tab.addEventListener('keydown', (event) => this.#handleKeydown(event, index), {
          signal: this.#controller.signal,
        });
      }

      this.#track.addEventListener('scroll', () => {
        clearTimeout(this.#scrollTimer);
        if (this.#drag) return;
        this.#scrollTimer = setTimeout(() => {
          const index = Math.round(this.#track.scrollLeft / this.#track.clientWidth);
          this.#activate(index, false);
        }, 120);
      }, { passive: true, signal });
      this.#track.addEventListener('pointerdown', (event) => this.#startDrag(event), { signal });
      this.#track.addEventListener('pointermove', (event) => {
        if (!this.#drag || event.pointerId !== this.#drag.id) return;
        this.#track.scrollLeft = this.#drag.scrollLeft + this.#drag.x - event.clientX;
      }, { signal });
      this.#track.addEventListener('pointerup', (event) => this.#finishDrag(event), { signal });
      this.#track.addEventListener('pointercancel', (event) => this.#finishDrag(event), { signal });
      this.#track.addEventListener('keydown', (event) => this.#handleKeydown(event, this.#activeIndex), { signal });
      let trackWidth = this.#track.clientWidth;
      this.#resizeObserver = new ResizeObserver(() => {
        if (this.#track.clientWidth === trackWidth) return;
        trackWidth = this.#track.clientWidth;
        this.#track.scrollTo({ left: this.#activeIndex * this.#track.clientWidth, behavior: 'instant' });
      });
      this.#resizeObserver.observe(this.#track);
      this.dataset.initialized = 'true';
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#resizeObserver?.disconnect();
      clearTimeout(this.#scrollTimer);
      this.#drag = null;
      this.#track?.removeAttribute('data-dragging');
      delete this.dataset.initialized;
    }

    #activate(index, moveFocus, behavior = this.#motion()) {
      if (index < 0 || index >= this.#panels.length) return;
      this.#activeIndex = index;

      for (const [panelIndex, panel] of this.#panels.entries()) {
        const isActive = panelIndex === index;
        panel.toggleAttribute('data-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.tabIndex = isActive ? 0 : -1;
        panel.classList.toggle('lq-five-spray__panel--active', isActive);
      }

      for (const [tabIndex, tab] of this.#tabs.entries()) {
        const isActive = tabIndex === index;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        tab.classList.toggle('lq-five-spray__tab--active', isActive);
      }

      for (const [copyIndex, copy] of this.#copies.entries()) {
        copy.hidden = copyIndex !== index;
      }

      if (behavior !== null) {
        this.#track.scrollTo({ left: index * this.#track.clientWidth, behavior });
      }
      if (moveFocus) this.#tabs[index].focus({ preventScroll: true });

      const tabList = this.#tabs[index].parentElement;
      const tabBox = this.#tabs[index].getBoundingClientRect();
      const listBox = tabList.getBoundingClientRect();
      if (tabBox.left < listBox.left || tabBox.right > listBox.right) {
        tabList.scrollBy({ left: tabBox.left - listBox.left - (listBox.width - tabBox.width) / 2, behavior: this.#motion() });
      }
    }

    #motion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    }

    #startDrag(event) {
      // Horizontal dragging follows the pointer; vertical scrolling and pinch zoom stay native.
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (event.pointerType === 'mouse') event.preventDefault();
      clearTimeout(this.#scrollTimer);
      this.#track.scrollTo({ left: this.#track.scrollLeft, behavior: 'instant' });
      this.#drag = { id: event.pointerId, x: event.clientX, scrollLeft: this.#track.scrollLeft, index: this.#activeIndex };
      this.#track.setAttribute('data-dragging', '');
      this.#track.setPointerCapture(event.pointerId);
    }

    #finishDrag(event) {
      if (!this.#drag || event.pointerId !== this.#drag.id) return;
      const distance = this.#track.scrollLeft - this.#drag.scrollLeft;
      const threshold = Math.min(60, this.#track.clientWidth * .15);
      const step = Math.abs(distance) > threshold ? Math.sign(distance) : 0;
      const index = Math.max(0, Math.min(this.#panels.length - 1, this.#drag.index + step));
      this.#drag = null;
      this.#track.removeAttribute('data-dragging');
      if (this.#track.hasPointerCapture(event.pointerId)) this.#track.releasePointerCapture(event.pointerId);
      this.#activate(index, false);
    }

    #handleKeydown(event, index) {
      const lastIndex = this.#tabs.length - 1;
      const nextIndexByKey = {
        ArrowLeft: index === 0 ? lastIndex : index - 1,
        ArrowRight: index === lastIndex ? 0 : index + 1,
        Home: 0,
        End: lastIndex,
      };

      if (!(event.key in nextIndexByKey)) return;

      event.preventDefault();
      this.#activate(nextIndexByKey[event.key], true);
    }
  }

  if (!customElements.get('lq-product-spray-showcase')) {
    customElements.define('lq-product-spray-showcase', LqProductSprayShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-product-information-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lq-product-tabs')) {
    class LqProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        for (const tab of this.tabs) {
          tab.addEventListener('click', this.handleClick);
          tab.addEventListener('keydown', this.handleKeydown);
        }
      }

      disconnectedCallback() {
        for (const tab of this.tabs || []) {
          tab.removeEventListener('click', this.handleClick);
          tab.removeEventListener('keydown', this.handleKeydown);
        }
      }

      handleClick = (event) => { this.activateTab(event.currentTarget, false); };

      handleKeydown = (event) => {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;
        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      };

      activateTab = (nextTab, moveFocus) => {
        const target = nextTab.dataset.lqTab;
        for (const tab of this.tabs) {
          const isActive = tab === nextTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        }
        for (const panel of this.panels) panel.hidden = panel.dataset.lqPanel !== target;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nextTab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' });
        if (moveFocus) nextTab.focus();
      };
    }
    customElements.define('lq-product-tabs', LqProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-product-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lq-sticky-buy')) {
    customElements.define('lq-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
        this.price = this.querySelector('[data-sticky-price]');
        this.selection = this.querySelector('[data-sticky-selection]');
        this.variantId = this.querySelector('[data-sticky-variant-id]');
        this.quantity = this.querySelector('[data-sticky-quantity]');
        this.button = this.querySelector('[data-sticky-add]');
        this.main = document.querySelector('product-info[id^="MainProduct-"]');
        this.mainForm = this.main?.querySelector('form[data-type="add-to-cart-form"]');
        this.primaryPurchase = this.main?.querySelector('[id^="ProductSubmitButton-"]');
        this.titleElement = this.main?.querySelector('.product__title');
        this.finalPurchase = document.querySelector('.lq-product-final button[type="submit"]');
        this.handleChange = (event) => {
          if (!this.main?.contains(event.target)) return;
          if (event.target.closest('variant-selects')) {
            this.button.disabled = true;
            return;
          }
          if (event.target.name === 'id' || event.target.name === 'quantity') this.syncVariant();
        };
        document.addEventListener('change', this.handleChange);
        document.addEventListener('input', this.handleChange);
        this.handleSubmit = () => this.syncVariant();
        this.querySelector('form').addEventListener('submit', this.handleSubmit);

        this.handleVisibility = () => {
          const height = window.innerHeight;
          const inView = (element) => {
            const rect = element?.getBoundingClientRect();
            return rect && rect.bottom > 0 && rect.top < height;
          };
          const titleReached = this.titleElement && this.titleElement.getBoundingClientRect().top < height;
          this.classList.toggle('is-visible', titleReached && !inView(this.primaryPurchase) && !inView(this.finalPurchase));
        };
        window.addEventListener('scroll', this.handleVisibility, { passive: true });
        window.addEventListener('resize', this.handleVisibility);
        this.handleVisibility();
        this.syncVariant();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleChange);
        document.removeEventListener('input', this.handleChange);
        this.querySelector('form').removeEventListener('submit', this.handleSubmit);
        window.removeEventListener('scroll', this.handleVisibility);
        window.removeEventListener('resize', this.handleVisibility);
      }

      syncVariant() {
        const currentId = this.mainForm?.querySelector('[name="id"]')?.value;
        const variant = this.variants.find((item) => String(item.id) === currentId);
        const quantityInput = this.main?.querySelector('.quantity__input');
        this.quantity.value = quantityInput?.value || '1';
        this.variantId.value = variant ? String(variant.id) : '';
        this.button.disabled = !variant?.available || (quantityInput && !quantityInput.validity.valid);
        this.button.textContent = variant?.available ? this.button.dataset.availableLabel : this.button.dataset.soldOutLabel;
        if (!variant) return;
        this.price.textContent = variant.price;
        this.selection.textContent = variant.label + (Number(this.quantity.value) > 1 ? ' · Qty ' + this.quantity.value : '');
        this.handleVisibility?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-routine-upgrade-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lq-routine-buy]');
    if (!trigger) return;

    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!productInfo) return;

    event.preventDefault();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    productInfo.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-s1-install"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lq-s1-install-control')) {
    customElements.define('lq-s1-install-control', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.video.muted = true;
        this.video.addEventListener('pause', () => {
          if (this.autoPausing) { this.autoPausing = false; return; }
          this.userPaused = true;
        }, options);
        this.video.addEventListener('play', () => { this.userPaused = false; }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          if (this.inView) this.loadVideo();
          this.updatePlayback();
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.pauseVideo();
          else this.updatePlayback();
        }, options);
      }
      loadVideo() {
        if (this.video.getAttribute('src')) return;
        if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
        this.video.src = this.video.dataset.src;
        this.video.load();
      }
      pauseVideo() {
        if (!this.video.paused) {
          this.autoPausing = true;
          this.video.pause();
        }
      }
      async updatePlayback() {
        if (!this.inView || document.hidden) { this.pauseVideo(); return; }
        if (this.dataset.autoplay !== 'true' || this.motion.matches || this.userPaused) return;
        try { await this.video.play(); } catch { /* The native play button is available if autoplay is blocked. */ }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liberaquar-s1-switch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lq-s1-switch-video')) {
    customElements.define('lq-s1-switch-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.video.muted = true;
        this.video.addEventListener('pause', () => {
          if (this.autoPausing) { this.autoPausing = false; return; }
          this.userPaused = true;
        }, options);
        this.video.addEventListener('play', () => { this.userPaused = false; }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          if (this.inView) this.loadVideo();
          this.updatePlayback();
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.pauseVideo();
          else this.updatePlayback();
        }, options);
      }
      loadVideo() {
        if (this.video.getAttribute('src')) return;
        if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
        this.video.src = this.video.dataset.src;
        this.video.load();
      }
      pauseVideo() {
        if (!this.video.paused) {
          this.autoPausing = true;
          this.video.pause();
        }
      }
      async updatePlayback() {
        if (!this.inView || document.hidden) { this.pauseVideo(); return; }
        if (this.dataset.autoplay !== 'true' || this.motion.matches || this.userPaused) return;
        try { await this.video.play(); } catch { /* The native play button is available if autoplay is blocked. */ }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
